@if (_citations().length > 0) {
  <div class="citation-sources">
    <button class="citation-sources-toggle" type="button" (click)="_toggle()">
      <span class="citation-sources-toggle-label">
        {{ chatWordings.citationSources() }} ({{ _citations().length }})
      </span>
      <span
        class="citation-sources-toggle-icon"
        [class.citation-sources-toggle-icon--expanded]="_isExpanded"
      ></span>
    </button>

    @if (_isExpanded) {
      <ul class="citation-list">
        @for (citation of _citations(); track citation.marker) {
          <li class="citation-item">
            <span class="citation-chip">[{{ citation.marker }}]</span>
            <div class="citation-body">
              <span class="citation-statement">{{ citation.statement }}</span>
              <span class="citation-source">
                <span class="citation-source-worker">{{
                  _workersOf(citation)
                }}</span>
                @if (_toolsOf(citation); as tools) {
                  <span class="citation-source-sep"> · </span>
                  <span class="citation-source-tools">{{ tools }}</span>
                }
              </span>
            </div>
            <button
              class="citation-open"
              type="button"
              (click)="_openDetail(citation)"
            >
              {{ chatWordings.citationOpenSource() }}
            </button>
          </li>
        }
      </ul>
    }
  </div>
}
